import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import CoursePath from '@/models/CoursePath';

type getFormattedCoursePathVersionType = {
  coursePath?: CoursePath;
};

export default function getFormatedCoursePathVersion({
  coursePath,
}: getFormattedCoursePathVersionType) {
  if (!coursePath) return null;
  return `V ${coursePath.version.toFixed(
    coursePath.status === VersioningStatusEnum.EDITING ? 2 : 1,
  )}`;
}
